import { useQuery } from '@tanstack/react-query';
import { showCaseService } from 'v2/services/showcase';

export const useShowCase = (producerId: number) => {
  const { data, isLoading, error } = useQuery({
    queryKey: ['showcase-profile', producerId],
    queryFn: () => showCaseService.showcaseProfile(producerId),
    enabled: !!producerId
  });

  return {
    data: data?.data,
    isFetching: isLoading,
    error
  };
};
